






























































































import { PaperGeneratedItem } from '@/resource/paper-generated-item/paper-generated-item.model';
import { Component, Prop, Vue } from 'vue-property-decorator';
import GeneratedQuestionContainer from '@/main-components/question-generated/GeneratedQuestionContainer.vue';
import MainButton from '@/main-components/common/MainButton.vue';

@Component({ components: { GeneratedQuestionContainer, MainButton } })
export default class PaperGeneratedItemContainer extends Vue {
  @Prop({ required: true })
  paperGeneratedItem!: PaperGeneratedItem;

  @Prop({ required: true })
  generateNewClick!: (paperGeneratedItem: PaperGeneratedItem) => {};
}
